import CurrentUserContainer from '@shared/hooks/state/CurrentUserContainer';
import OrganizationContainer from '@shared/hooks/state/OrganizationContainer';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import Button from '../core/button/CoreButton';
import SubSectionRow from '../core/headers/SubSectionRow';
import { SubSectionContent } from '../core/layouts/CommonLayoutStyles';
import SelectOrganizationUpgradeDialog from '../organization/billing/SelectOrganizationUpgradeDialog';
import ActivateLicenseMinorCTA from './ActivateLicenseMinorCTA';

// authorized user for Cephable Basic has organizations
export default function ExpiredLicenseCard() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const organizationContainer = OrganizationContainer.useContainer();
    const currentUserContainer = CurrentUserContainer.useContainer();
    const [showDialog, setShowDialog] = useState(false);
    const isSingleMembership = organizationContainer.memberships.length == 1;

    if (!currentUserContainer.isEmailVerified || !currentUserContainer.isLicenseExpired) {
        return null;
    }

    const getTitle = () => {
        return isSingleMembership
            ? t('common:organization.expired.title')
            : t('common:organization.expired.titlePlural');
    };
    const getDescription = () => {
        if (isSingleMembership) {
            const { isAdmin, canManageBilling } = organizationContainer.memberships[0];
            return canManageBilling || isAdmin
                ? t('common:organization.expired.admin')
                : t('common:organization.expired.user');
        }
        return t('common:organization.expired.multiple');
    };

    const handleClick = () => {
        if (isSingleMembership) {
            navigate(`/org/${organizationContainer.memberships[0].organizationId}/billing/redirect/upgrade/`);
        } else {
            setShowDialog(true);
        }
    };

    return (
        <>
            <SubSectionRow title={getTitle()} description={getDescription()} />
            <SubSectionContent>
                {isSingleMembership ? (
                    <>
                        <ActivateLicenseMinorCTA
                            organizationId={organizationContainer.memberships[0].organizationId}
                            center={false}
                        />
                        <Button onClick={handleClick} $color="secondary">
                            {t('common:upgrade')}
                        </Button>
                    </>
                ) : (
                    <>
                        <Button onClick={handleClick} $color="secondary">
                            {t('common:organization.viewOrganization')}
                        </Button>
                        <SelectOrganizationUpgradeDialog open={showDialog} onCancel={() => setShowDialog(false)} />
                    </>
                )}
            </SubSectionContent>
        </>
    );
}
